(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/image-v2/assets/javascripts/helpers/multi-image-style-element.js') >= 0) return;  svs.modules.push('/components/content/image-v2/assets/javascripts/helpers/multi-image-style-element.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

var toArrayOrNull = svs.content.image_v2.helpers.toArrayOrNull;

var setStyleElement = function setStyleElement(contentId, images) {
  var text = {
    styleTagId: 'image-v2',
    prefix: 'Styles for'
  };
  var head = document.querySelector('head');

  var getMediaQueriesString = function getMediaQueriesString(image, selector) {
    var _ref = image || {},
      aspectRatio = _ref.aspectRatio,
      dominantColor = _ref.dominantColor,
      media = _ref.media;
    var declarations = [aspectRatio && "padding-bottom: ".concat(aspectRatio.height / aspectRatio.width * 100, "%;"), dominantColor && "background-color: ".concat(dominantColor, ";")];
    var declarationsString = declarations.filter(function (item) {
      return Boolean(item);
    }).join('\n\t\t');
    return "@media only screen and ".concat(media, " {") + "\n\t.".concat(selector, " {") + "\n\t\t".concat(declarationsString, "\n\t") + "}\n}";
  };

  var hasMediaQueries = function hasMediaQueries(images) {
    return (images === null || images === void 0 ? void 0 : images.some(function (item) {
      return item && 'media' in item && 'aspectRatio' in item;
    })) || false;
  };

  var arrayToCssString = function arrayToCssString(input) {
    var output = input === null || input === void 0 ? void 0 : input.map(function (_ref2) {
      var id = _ref2.id,
        content = _ref2.content;
      var cssComment = "/* ".concat(text.prefix, " ").concat(id, " */\n\n");
      var style = "".concat(content, "\n\n");
      return "".concat(cssComment).concat(style).trim();
    });
    return (output === null || output === void 0 ? void 0 : output.join('\n\n')) || '';
  };

  var cssStringToArray = function cssStringToArray(input) {
    var regex = new RegExp("\\/\\*\\s".concat(text.prefix, "(.*?)\\s\\*\\/([\\s\\S]*?)(?=\\/\\*\\s").concat(text.prefix, "|$)"), 'g');
    var matches = input.match(regex);
    var styles = matches.map(function (match) {
      regex.lastIndex = 0;
      var match2 = regex.exec(match) || [];
      var _match = _slicedToArray(match2, 3),
        id = _match[1],
        content = _match[2];
      return {
        id: id === null || id === void 0 ? void 0 : id.trim(),
        content: content === null || content === void 0 ? void 0 : content.trim()
      };
    }) || [];
    return styles;
  };

  var getStyleElement = function getStyleElement(id) {
    var existingElement = head.querySelector("#".concat(id));
    var hasExistingElement = Boolean(existingElement);
    var styleElement = hasExistingElement ? existingElement : document.createElement('style');
    return [styleElement, hasExistingElement];
  };
  var init = function init() {
    var imagesArray = toArrayOrNull(images);
    if (!hasMediaQueries(imagesArray)) {
      return;
    }
    var cssDeclarationString = imagesArray.map(function (image) {
      return getMediaQueriesString(image, contentId);
    }).join('\n');
    var _getStyleElement = getStyleElement(text.styleTagId),
      _getStyleElement2 = _slicedToArray(_getStyleElement, 2),
      styleElement = _getStyleElement2[0],
      hasExistingStyleElement = _getStyleElement2[1];
    if (hasExistingStyleElement) {
      var _cssArray = cssStringToArray(styleElement.textContent);
      var thisIdIndex = _cssArray.findIndex(function (item) {
        return item.id === contentId;
      });
      var newValue = {
        id: contentId,
        content: cssDeclarationString
      };
      if (thisIdIndex !== -1) {
        _cssArray[thisIdIndex] = newValue;
      } else {
        _cssArray.push(newValue);
      }
      var cssString = arrayToCssString(_cssArray);
      styleElement.textContent = cssString;
      return;
    }

    styleElement.id = text.styleTagId;
    var cssArray = [{
      id: contentId,
      content: cssDeclarationString
    }];
    styleElement.textContent = arrayToCssString(cssArray);
    head.appendChild(styleElement);
  };
  init();
};


var setupForImageElement = function setupForImageElement(element) {
  var _element$dataset;
  var id = element === null || element === void 0 || (_element$dataset = element.dataset) === null || _element$dataset === void 0 ? void 0 : _element$dataset.multiImageId;
  if (id) {
    var dataString = element.dataset.multiImageDataString;
    var data = JSON.parse(dataString);
    setStyleElement(id, data);
    delete element.dataset.multiImageDataString;
    delete element.dataset.multiImageId;
  }
};
svs.content.image_v2.helpers.multiImageStyleElement = {
  setupForImageElement: setupForImageElement,
  setStyleElement: setStyleElement
};

 })(window);